import { Directive, ElementRef, Input } from '@angular/core';
import { Desktop } from 'src/app/core/api/models';

@Directive({
  selector: '[desktop]',
  standalone: true,
})
export class DesktopDirective {
  @Input('desktop') desktop: Desktop;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi tw-min-w-[90px] tw-py-2 tw-font-medium mdi-20px badge ';

    switch (this.desktop) {
      case Desktop.Default:
        classList += 'badge-light-info';
        break;
      case Desktop.ErshadDesktop:
        classList += 'badge-light-sky';
        break;
      case Desktop.ElectionDesktop:
        classList += 'badge-light-warning';
        break;

      default:
        classList += 'badge-light-navyBlue';
        break;
    }
    return classList;
  }
}
